import {createAction, props} from '@ngrx/store';

export const userLogin = createAction('[Auth] User Login',
  props<{ email: string; cognitoUser: any; redirect: boolean; url: string }>());
export const userLogout = createAction('[Auth] User Logout');
